import React from "react";
import TopBar from "./TopBar";
import SideNav from "./SideNav";
export default function AdminLayout({ children, ...rest }) {
  return (
    <React.Fragment>
      <TopBar />
      <SideNav>{children}</SideNav>
    </React.Fragment>
  );
}
